export default __webpack_public_path__ + "static/media/uploader-ascensiaContour-4.48fd3999.png";